import React from 'react';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { formModes } from '@store/policies/schedule/formReducer';
import { setEmailIds } from '@store/policies/schedule/actions';
import { FieldWrapper } from './styled';

const { Option } = Select;

function Email({ emailList }) {
  const dispatch = useDispatch();
  const { mode, emailIds } = useSelector(formViewSelector);

  const options = emailList.map((mail) => (
    <Option key={mail} title={mail}>
      {' '}
      {mail}{' '}
    </Option>
  ));

  const handleChange = (values) => {
    dispatch(setEmailIds(values));
  };

  return (
    <FieldWrapper>
      <Select
        mode="tags"
        style={{ width: '100%' }}
        onChange={handleChange}
        tokenSeparators={[',', ';']}
        allowClear
        optionFilterProp="title"
        disabled={mode === formModes.delete}
        defaultValue={emailIds || []}
        placeholder="Add email addresses separated by commas"
      >
        {options}
      </Select>
    </FieldWrapper>
  );
}

export default React.memo(Email);
